import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {PickParentTagDropdownBox} from '../../../components/common/dropdowns/tags/pickParentTagDropdownBox';
import {SearchTagModel} from '../../../models/api/searchTagModel';
import {TagModel} from '../../../models/api/tagModel';
import {SettingsFieldLine} from '../../common/settingsFieldLine';

/*
 * Props.
 */

interface SettingsSingleTagParentTagFieldProps {
  namespace: string;
  onTagSelect: HandlerOf<SearchTagModel | undefined>;
  selectedTag: TagModel;
  excludeTagId?: number;
}

/*
 * Style.
 */

const StyledParentTagPickerDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 240px;
`;

/*
 * Component.
 */

export const SettingsSingleTagParentTagField: FC<SettingsSingleTagParentTagFieldProps> = (props) => {
  const renderParentTagPicker = () => (
    <StyledParentTagPickerDiv>
      <PickParentTagDropdownBox
        namespace={props.namespace}
        onTagSelect={props.onTagSelect}
        selectedTag={props.selectedTag}
        excludeTagId={props.excludeTagId}
        shouldHideLabel
        dropdownWidth={300}
      />
    </StyledParentTagPickerDiv>
  );

  return (
    <SettingsFieldLine
      title={<Trans id="settingstags-nest-title">Nest tag under</Trans>}
      subtitle={
        <Trans id="settingstags-nest-subtitle">Organize this tag and its subtags under a parent tag</Trans>
      }
      content={renderParentTagPicker()}
    />
  );
};
